import { render, staticRenderFns } from "./VDragAndDropFiles.vue?vue&type=template&id=15e43a6b&scoped=true"
import script from "./VDragAndDropFiles.vue?vue&type=script&lang=js"
export * from "./VDragAndDropFiles.vue?vue&type=script&lang=js"
import style0 from "./VDragAndDropFiles.vue?vue&type=style&index=0&id=15e43a6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e43a6b",
  null
  
)

export default component.exports